export default __webpack_public_path__ + "static/media/vpAccidental.171c4149.svg";